<template>
	<c-dialog ref="dialog" width="900" height="600" :show-foot="false">
		<div class="point-view">
			<div v-if="pointList.length == 0" class="empty-tip">暂无点位数据</div>
			<div class="point-grid">
				<div class="point-card" v-for="item in pointList" :key="item.id">
					<div class="card-header">
						<span class="point-code">{{ item.point_code }}</span>
						<c-state dict="disableEnableDic" :value="item.state"></c-state>
					</div>
					<div class="card-body">
						<div class="info-row">
							<span class="info-label">点位ID：</span>
							<span class="info-value" :title="item.device_point_id">{{ item.device_point_id || '-' }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</c-dialog>
</template>

<script>
	export default {
		data() {
			return {
				equipmentId: 0,
				pointList: []
			}
		},
		methods: {
			open(data) {
				this.equipmentId = data.id;
				this.loadData();
				this.$refs.dialog.open({
					title: '【' + data.equipment_code + '】点位查看'
				});
			},

			loadData() {
				this.request({
					url: '/equipment/point/listByEquipmentId',
					data: {
						equipment_id: this.equipmentId
					},
					loading: true,
					success: data => {
						this.pointList = data || [];
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
.point-view
	padding 10px 15px

.empty-tip
	text-align center
	padding 40px 0
	color #999
	font-size 14px

.point-grid
	display flex
	flex-wrap wrap
	gap 12px

.point-card
	width calc(25% - 9px)
	box-sizing border-box
	border 1px solid #e8e8e8
	border-radius 6px
	padding 12px
	background #fff
	transition box-shadow 0.2s

	&:hover
		box-shadow 0 2px 8px rgba(0,0,0,0.08)

.card-header
	display flex
	justify-content space-between
	align-items center
	margin-bottom 10px

.point-code
	font-size 15px
	font-weight bold
	color #333

.card-body
	.info-row
		display flex
		align-items center
		font-size 13px
		color #666
		margin-bottom 6px

		&:last-child
			margin-bottom 0

	.info-label
		color #999
		flex-shrink 0

	.info-value
		overflow hidden
		text-overflow ellipsis
		white-space nowrap
</style>
